import React, { memo, useCallback, useState } from "react";
import { Video } from "../../../../common/video/models/Video";
import stylesPc from "./ContentCard.module.css";
import stylesSp from "./ContentCard_SP.module.css";
import { Link, useHistory } from "react-router-dom";
// import { VideoTag } from "../../../../common/video/models/VideoTag";
// import Tag from "../../../../common/components/tag/Tag";
// import { SpacedList, SpacedListItem } from "../../../../common/components/spacedList/SpacedList";
import VideoPresenter from "../../../../common/components/video/presenter/VideoPresenter";
import VideoMenu from "../../../../common/components/videoMenu/VideoMenu";
import EditAndUploadToHubModal from "../../../../components/widgets/EditAndUploadToHubModal";
import LinearProgress from "@material-ui/core/LinearProgress";
import PuiTooltip from "../../../../components/elements/PuiTooltip ";
import PuiTypography from "../../../../components/elements/PuiTypography";
import { createStyles, makeStyles } from "@material-ui/core";
import EditSlideStock from "../../../videoPlayer/components/slideStockEdit/EditSlideStock";
import { IsDevice } from "../../../../components/function/useDeviceFlag";
import { MoreVert } from "@material-ui/icons";
import { isAdmin, isEditor } from "../../../../utils/LogicUtils";
import { useSelector } from "react-redux";
import { AppState } from "../../../../root/RootReducer";

interface ContentCardProps {
    content: any;
    setMsg: (msg: string) => void;
}

const useStyles = makeStyles(() =>
    createStyles({
        barColorPrimary: {
            backgroundColor: "var(--studio-btn-bg)",
        },
    })
);

function ContentCard({ content, setMsg }: ContentCardProps) {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;
    const classes = useStyles();
    const history = useHistory();

    // ユーザー取得
    const { user } = useSelector((state: AppState) => ({
        user: state.user.user,
    }));

    // 視聴履歴の進捗インジケータを計算
    const normalise = (content: Video) => {
        if (!content.viewingActivities || content.viewingActivities.length === 0) {
            return 0;
        } else {
            const progressMillis = content.viewingActivities[0].progressMillis;
            const isFinished = content.viewingActivities[0].isFinished;
            if (progressMillis !== null) {
                const rate = Math.floor(
                    (Number(progressMillis) / Number(content.durationMillis)) * 100
                );

                return rate;
            } else if (progressMillis === null && isFinished) {
                return 100;
            }
        }
    };

    // const avater = avaterStyles();
    // ビデオ詳細画面遷移
    const goToVideo = useCallback(() => history.push(`/video/${content.id}`), [content, history]);

    // コンテンツ詳細画面遷移
    const goToContent = useCallback(
        () => history.push(`/slidestock/${content.id}`),
        [content, history]
    );

    //コンテンツ管理者編集ボタン表示index
    const [contentIndex, setContentIndex] = useState<number>(-1);

    //コンテンツ管理者編集ボタン押下時
    const ChangeContentIndex = (index: number) => {
        setContentIndex(index);
    };

    return (
        <div className={styles.card}>
            <div className={styles.thumbnaildiv}>
                {/* ビデオ情報表示 */}
                {content.fileType !== "slidestock" && (
                    <img
                        className={styles.thumbnail}
                        src={content.imageUrl}
                        alt=""
                        onClick={goToVideo}
                        onError={(e) =>
                            (e.currentTarget.src =
                                require("../../../../assets/image/NoImage.jpg").default)
                        }
                    />
                )}

                {/* スライド情報 */}
                {content.fileType === "slidestock" && (
                    <img
                        className={styles.thumbnail}
                        src={content.imageUrl}
                        alt=""
                        onClick={goToContent}
                        onError={(e) =>
                            (e.currentTarget.src =
                                require("../../../../assets/image/NoImage.jpg").default)
                        }
                    />
                )}

                {(isAdmin(user?.roles) || isEditor(user?.roles)) && (
                    <div onClick={() => ChangeContentIndex(content.id)} className={styles.moreIcon}>
                        <MoreVert />
                    </div>
                )}
                {content.id === contentIndex && (
                    <>
                        <div
                            className={styles.menuItem}
                            style={{
                                height: content.fileType !== "slidestock" ? "88px" : "57px",
                                bottom: content.fileType !== "slidestock" ? "10px" : "43px",
                            }}
                        >
                            <div>
                                {/* ビデオ編集ボタン */}
                                {!content.fileType && <EditAndUploadToHubModal video={content} />}
                                {/* コンテンツ編集ボタン表示 */}
                                {content.fileType === "slidestock" && (
                                    <EditSlideStock slideId={content.id} />
                                )}
                            </div>
                            <div>
                                {!content.fileType && (
                                    <VideoMenu
                                        video={content}
                                        videoId={content.id}
                                        setMsg={setMsg}
                                    />
                                )}
                            </div>
                        </div>
                        <div
                            className={styles.selectOtherArea}
                            onClick={() => ChangeContentIndex(-1)}
                        />
                    </>
                )}

                {/* 新規ビデオアイコン */}
                {content.visibleNewIcon && (
                    <img
                        src={require("../../../../assets/image/newIcon.svg").default}
                        className={styles.newIcon}
                        alt={`newIcon_${content.id}`}
                    />
                )}
            </div>
            <LinearProgress
                className={styles.progressBar}
                classes={{ barColorPrimary: classes.barColorPrimary }}
                style={{ height: "2px" }}
                variant="determinate"
                value={normalise(content)}
            />
            {/* <div className={styles.text} onClick={goToVideo}> */}
            <div className={styles.text}>
                {content.fileType !== "slidestock" && (
                    <Link to={`/video/${content.id}`}>
                        <div
                            className={styles.cardTitle}
                            data-for="listtitle"
                            data-tip={content.title}
                        >
                            <PuiTypography size="videoTitle" bold={true}>
                                {content.title}
                            </PuiTypography>
                        </div>
                        <PuiTooltip id="listtitle" />
                    </Link>
                )}
                {content.fileType === "slidestock" && (
                    <Link to={`/slidestock/${content.id}`}>
                        <div
                            className={styles.cardTitle}
                            data-for="listtitle"
                            data-tip={content.title}
                        >
                            <PuiTypography size="videoTitle" bold={true}>
                                {content.title}
                            </PuiTypography>
                        </div>
                        <PuiTooltip id="listtitle" />
                    </Link>
                )}
                <VideoPresenter presenter={content.presenter} content={content} />
                <div
                    className={styles.cardTags}
                    style={{
                        display: content.tags && content.tags.length > 0 ? "flex" : "none",
                        height: content.tags && content.tags.length === 0 ? "0" : "",
                    }}
                >
                    {/* ビデオ */}
                    {/* {!content.fileType && content.tags.length > 0 && (
                        <SpacedList>
                            {content.tags.map((tag: VideoTag) => (
                                <SpacedListItem key={tag}>
                                    <Tag tag={tag} />
                                </SpacedListItem>
                            ))}
                        </SpacedList>
                    )} */}

                    {/* スライド */}
                    {/* {content.fileType && content.tags.length > 0 && (
                        <SpacedList>
                            {content.tags.map(
                                (tag: string, index: React.Key | null | undefined) => (
                                    <SpacedListItem key={index}>
                                        <Tag contentTag={tag} />
                                    </SpacedListItem>
                                )
                            )}
                        </SpacedList>
                    )} */}
                </div>
            </div>
        </div>
    );
}

export default memo(ContentCard);
